const formatNumber = (value, precision) => {
  if (value == null || precision == null || isNaN(value)) return null;

  var number = Number(value);
  var myRegexp = /^([-]?)(\d*)([.]?)(\d*)$/g;
  var match = myRegexp.exec(number);
  let formattedValue = '';
  formattedValue += match[1] === '-' ? '-' : '';

  // not a fractional value either pad with 0s based on precision if not 0 or return the same value if precision is 0
  if (match[3] === '') {
    formattedValue +=
      precision > 0 ? number + '.' + '0'.repeat(precision) : number;
  } else {
    //if fractional, construct the left hand side of the decimal point first
    formattedValue += match[2] === '' ? '0' : match[2];

    // if precision is less than 1 then we return the left side of the decimal point only
    if (precision > 0) {
      formattedValue += '.';
      //truncate trailing zeroes
      if (match[4].length > precision) {
        formattedValue += match[4].slice(0, precision);
      }
      // pad with trailing zeroes
      else if (match[4].length < precision) {
        formattedValue += match[4] + '0'.repeat(precision - match[4].length);
      } else {
        formattedValue += match[4];
      }
    }
  }

  return formattedValue;
};

const checkPrecisionLength = (value, precision) => {
  var myRegexp = /^(\d*)([.]?)(\d*)$/g;
  var match = myRegexp.exec(value);
  return match[2] === '.' && match[3].length > precision;
};

export { formatNumber, checkPrecisionLength };
